import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { CurrentDelegationBlock } from '../blocks/CurrentDelegationBlock'
import { getCurrentDelegationRanges } from '../utils/currentDelegationRanges'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const CurrentDelegationsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { allEvents } = useTimelineData()

  const ranges = React.useMemo(
    () => getCurrentDelegationRanges(allEvents),
    [allEvents],
  )

  return (
    <LayerWrapper zIndex={zIndex}>
      {ranges.map((range, index) => (
        <CurrentDelegationBlock
          key={index}
          begin={range.start}
          end={range.end}
          index={index}
        />
      ))}
    </LayerWrapper>
  )
}

export default CurrentDelegationsLayer
